module.exports = __webpack_public_path__ + "img/BanksBeta.c97afe8d.svg";